// extracted by mini-css-extract-plugin
module.exports = {"get-next":"components-ContentHeader-GetNext-GetNext__get-next--3nV4r","get-next-disabled":"components-ContentHeader-GetNext-GetNext__get-next-disabled--1LEAH"};